import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, from, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserService } from '../user-service/userservice';

@Injectable({ providedIn: 'root' })
export class PlatformAdminGuard implements CanActivate {
  constructor(
    private readonly userService: UserService,
    private readonly router: Router
  ) { }

  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> {
    if (this.userService.isCurrentUserPlatformAdmin()) return true;

    return from(this.userService.updateAuthorisation()).pipe(
      map(() => this.userService.isCurrentUserPlatformAdmin()
        ? true
        : this.router.parseUrl('/marktplatz')),
      catchError(() => of(this.router.parseUrl('/marktplatz')))
    );
  }
}
